import { routePathName } from '@app/app.models';
import { SystemAlertId } from './_constants';

/**
 * @title => short title for banners
 * @message => paragraph of text for explanation of alert, in tooltips/popups etc.
 * @ type => type of system alert see SystemAlertType enum
 * @timeout => null OR number of seconds to auto cancel alert (listed as any as it is )
 *
 */
export interface ISystemAlert {
	title: string;
	message: string;
	type: SystemAlertType;
	id?: string;
	timeout?: number;
	cancellable?: boolean;
	link?: routePathName;
	blockingTypes?: SystemBlockingType[];
	callback?: () => void;
}

export enum SystemBlockingType {
	companyCreate = 'companyCreate',
	companyDelete = 'companyDelete',
	companyUpdate = 'companyUpdate',
	companyAll = 'companyCreate, companyDelete, companyUpdate',
	appkeyCreate = 'appkeyCreate',
	appkeyDelete = 'appkeyDelete',
	appkeyUpdate = 'appkeyUpdate',
	appkeyAll = 'appkeyCreate, appkeyDelete, appkeyUpdate',
	legalCreate = 'legalCreate',
	legalUpdate = 'legalUpdate',
	legalAccept = 'legalAccept',
	legalAll = 'legalCreate, legalUpdate, legalAccept',
	contactUpdate = 'contactUpdate',
	contactDelete = 'contactDelete',
	contactAll = 'contactUpdate, contactDelete'
}

/**
 * what type of alert is this
 * if adding types, also add scss colors in src/scss/utility/colors.scss file
 */
export enum SystemAlertType {
	all = 'all',
	critical = 'critical',
	warning = 'warning',
	note = 'note',
	achievement = 'achievement'
}

export enum SystemAlertAction {
	cancelled = 'cancelled',
	completed = 'completed',
	timeout = 'timeout'
}

export enum SystemAlert {
	emailVerified = 'emailVerified',
	zone5Acceptance = 'zone5Acceptance'
}
